import { createApp } from 'vue'
import App from './App.vue'

// Include main.css file
import '@/assets/main.css'

import './registerServiceWorker'

import router from './router';

createApp(App)
  .use(router)
  .mount('#app')
